import { render } from "./shopSetting.vue?vue&type=template&id=078455cc&scoped=true"
const script = {}

import "./shopSetting.vue?vue&type=style&index=0&id=078455cc&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078455cc"]])

export default __exports__